























































export default {
  methods: {
    auth (e: any) {
      if (process.env.CLIENT) {
        const el = e.currentTarget
        const { href, ...extra } = el.dataset
        const options = {
          resizable: 'yes',
          scrollbars: 'no',
          toolbar: 'no',
          menubar: 'no',
          location: 'no',
          directories: 'no',
          status: 'yes',
          width: 450,
          height: 380,
          ...extra
        }

        options.left = (window.screen.width - options.width) / 2
        options.top = (window.screen.height - options.height) / 2

        const popupFeatureParts: string[] = []
        Object.keys(options).forEach((name) => {
          popupFeatureParts.push(`${name}=${options[name]}`)
        })
        const popupFeature = popupFeatureParts.join(',')
        const popup = window.open(href, 'oauth', popupFeature)!
        popup.focus()
      }
    }
  }
}
